import { render, staticRenderFns } from "./DiscountsIndex.vue?vue&type=template&id=6b44856e&"
import script from "./DiscountsIndex.vue?vue&type=script&lang=js&"
export * from "./DiscountsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports